import { render, staticRenderFns } from "./PasswordRestore.vue?vue&type=template&id=7d79e7f2&"
import script from "./PasswordRestore.vue?vue&type=script&lang=ts&"
export * from "./PasswordRestore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports